import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { Seo } from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" description="The page you are looking for could not be found." noindex />
      <PageHeader kicker="404" title="We couldn't find that page"
        sub="The page you're looking for may have moved or no longer exists." />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-20 md:py-28 text-center" data-testid="not-found">
        <p className="text-lg text-ink">Try one of these instead:</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {[["Home", "/"], ["Services", "/services"], ["For Employers", "/employers"], ["For Candidates", "/careers"], ["Contact", "/contact"]].map(([label, to]) => (
            <Link key={to} to={to}
              className="px-6 py-3 rounded-full border border-slate-300 text-navy font-semibold hover:border-navy transition-colors">
              {label}
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
